<template>
  <div class="subject-list bgcolor-con">
    <div class="banner search">
      <h1>演讲专题</h1>
      <div class="input">
        <input type="text" id="search-input" :placeholder="placeholder" v-model="searchword" @keyup.enter="toSearch()">
        <button type="button" id="search-button" @click="toSearch()">搜索一下</button>
      </div>
      <div class="keyword">
        <router-link v-for="(item,index) in keywords[global.area_id]" :key="'keywords_'+index"
          :to="formatHref('/subject-detail', {vid: item.id})">
          {{item.name}}
        </router-link>
      </div>
    </div>
    <div class="pc_content">
      <Loading :loading="isLoading"></Loading>
      <div class="con" v-if="update">
        <slot v-if="subjectlist && 0 < subjectlist.length">
          <slot v-for="(item,index) in subjectlist">
            <section v-if="showlist[index][0] && !item.venueName.includes('开幕式')" :key="'subject_'+index">
              <router-link class="pro_top_01 all_a" :to="formatHref('/subject-detail', {vid: item.id})">
                <h1>{{item.venueName}}</h1>
                <p v-if="item.description&&item.description!=''" v-html="item.description"></p>
              </router-link>
              <ul class="pro_bot" v-if="item.differenceCourse && item.differenceCourse.length > 0">
                <slot v-for="(it, i) in item.differenceCourse">
                  <li class="course-div" v-if="showlist[index][1]" :key="'subject_course_'+i">
                    <div class="all">
                      <div class="top row">
                        <div class="le">
                          <div class="img">
                            <img src="../assets/img/per_back.png" class="per">
                            <img :src="(it.lecturers && it.lecturers[0] && it.lecturers[0].file) || it.file" class="img-circle" style="border-radius:0;">
                          </div>
                        </div>
                        <div class="ri">
                          <router-link :to="it.courseId ? formatHref('/course', {cid: it.courseId, dif:1, vid:item.id, source:global.area_id=='4488'?encodeURIComponent('腾讯云'):''}) : ''">
                            <h1 class="course-title">{{it.courseTitle}}</h1>
                            <h2 v-if="it.lecturers&&it.lecturers[0]">{{it.lecturers[0].name}} / {{it.lecturers[0].company}} <br> {{it.lecturers[0].position}}</h2>
                          </router-link>
                        </div>
                      </div>
                      <div class="bot"></div>
                    </div>
                  </li>
                </slot>
              </ul>
              <ul class="pro_bot" v-else>
                <slot v-for="(it, i) in item.schedulingCourse">
                  <li class="course-div" v-if="showlist[index][1][i]" :key="'subject_course_'+it.id">
                    <div class="all">
                      <div class="top row">
                        <div class="le">
                          <div class="img">
                            <img src="../assets/img/per_back.png" class="per">
                            <img :src="global.getSrc(it.thumbs)" class="img-circle">
                          </div>
                        </div>
                        <div class="ri">
                          <router-link :to="formatHref('/course', {cid: it.courseid})">
                            <h1 class="course-title">{{it.courseTitle}}</h1>
                            <h2>{{it.name}} / {{it.company}} <br> {{it.position}}</h2>
                          </router-link>
                        </div>
                      </div>
                      <div class="bot">
                        <a class="tag" v-if="it.tag&&it.tag!='default'">{{it.tag}}</a>
                      </div>
                    </div>
                  </li>
                </slot>
              </ul>
            </section>
          </slot>
          <p class="search_blank" v-if="searchresultshow">未搜索到 {{searchwordshow}} 相关专题或课程</p>
        </slot>
        <p class="search_blank" v-else>敬请期待</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../mixin'

export default {
  name: 'SubjectList',
  mixins: [mixinSession],
  components: {
    Loading: () => import('@/componentsNew/Loading.vue')
  },
  data () {
    return {
      subjectlist: [],
      showlist: [],
      update: true,
      placeholder: '输入领域或者关键词，查看相关主题',
      searchword: '',
      searchwordshow: '',
      searchresultshow: '',
      isLoading: false,
      keywords: {
        '2699': [
          // { name: '智能语音', id: '' },
          { name: '机器学习', id: '5346' },
          // { name: 'AI产品', id: '' },
          { name: '中台落地', id: '5330' },
          { name: '风控', id: '5341' },
          { name: '业务架构', id: '5331' },
          // { name: 'AIoT', id: '' },
          { name: 'AI开源', id: '5349' },
          { name: 'AIOps', id: '5325' },
          { name: 'NLP', id: '5348' },
          { name: '推荐/广告', id: '5340' },
          { name: '性能优化', id: '5332' },
          { name: '高可用架构', id: '5333' },
          { name: 'serverless', id: '5329' },
          { name: '计算机视觉', id: '5342' } ],
        '3639': [
          { name: '智能语音', id: '5666' },
          { name: '数据安全', id: '5656' },
          { name: '风控', id: '5673' },
          { name: '云数仓架构', id: '5659' },
          { name: 'AI框架', id: '5667' },
          { name: 'AIGC', id: '5669' },
          { name: 'NLP', id: '5665' },
          { name: '搜/推/广', id: '5674' },
          { name: '元宇宙', id: '5671' },
          { name: '音视频技术', id: '5661' },
          { name: 'serverless', id: '5653' },
          { name: '计算机视觉', id: '5664' } ]
      }
    }
  },
  created () {
    this.sizeChange()
    this.getSubject()
    window.addEventListener('resize', () => {
      this.sizeChange()
    })
  },
  methods: {
    sizeChange () {
      if (document.body.clientWidth > 600) {
        this.placeholder = '输入领域或者关键词，查看相关主题'
      } else {
        this.placeholder = '输入领域或者关键词'
      }
    },
    getSubject: function () {
      let surl = this.global.urlNew.subject + this.global.area_id
      this.$http.jsonp(surl)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          if ([0, '0'].includes(data.errno)) {
            // console.log('SubjectList ',data.data)
            this.subjectlist = data.data
            this.showlist = []
            for (let i = 0; i < data.data.length; i++) {
              this.showlist.push([true, []])
              for (let j = 0; j < data.data[i].schedulingCourse.length; j++) {
                this.showlist[i][1].push(true)
              }
            }
            this.getDifference()
          }
        })
    },
    noneShowList: function () {
      let flag = true
      for (let item of this.showlist) {
        if (!flag) {
          break
        } else {
          if (item[0]) {
            flag = false
            break
          } else {
            for (let node of item[1]) {
              if (node) {
                flag = false
                break
              }
            }
          }
        }
      }
      this.searchresultshow = flag
      this.searchwordshow = this.searchword
      // return flag;
    },
    toSearch: function () {
      this.isLoading = true
      if (!this.searchword || (typeof this.searchword === 'string' && this.searchword.trim() === '')) {
        this.searchword = ''
        for (let i = 0; i < this.subjectlist.length; i++) {
          for (let j = 0; j < this.subjectlist[i].schedulingCourse.length; j++) {
            this.showlist[i][1][j] = true
          }
          this.showlist[i][0] = true
        }
      } else {
        let flag0 = 0
        let flag = 0
        for (let i = 0; i < this.subjectlist.length; i++) {
          flag0 = (this.subjectlist[i].venueName.indexOf(this.searchword) === -1) ? 0 : 1
          flag = 0
          for (let j = 0; j < this.subjectlist[i].schedulingCourse.length; j++) {
            flag = (this.subjectlist[i].schedulingCourse[j].courseTitle.indexOf(this.searchword) === -1) ? 0 : 1
            if (flag) {
              this.showlist[i][1][j] = true
              flag0 = 1
            } else {
              this.showlist[i][1][j] = false
            }
          }
          if (flag0) {
            this.showlist[i][0] = true
          } else {
            this.showlist[i][0] = false
          }
        }
      }
      this.update = false
      this.update = true
      this.noneShowList()
      this.$forceUpdate()
      setTimeout(() => {
        this.isLoading = false
      }, 100)
      // console.log(this.searchword, this.showlist);
    },
    //
    getDifference () {
      if (this.global.config[this.global.area_id]['difference'] && parseInt(this.global.config[this.global.area_id]['difference'])) {
        let url = this.global.urlNew.sue['type'] + this.global.config[this.global.area_id]['difference']
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            // console.log('difference ', res)
            if ([0, '0'].includes(res.errno) && res.data) {
              let type = ''
              let typeList = []
              for (let item of res.data) {
                type = item.typeName && typeof item.typeName === 'string' && item.typeName.toLocaleLowerCase()
                if (type && type.includes('mpd') && type.includes(this.global.config[this.global.area_id].year)) {
                  typeList.push({ id: item.id, name: type.split('#')[1], clauseActivityId: type.split('#')[2] || '' })
                }
              }
              this.getScheduleDifference(typeList)
            }
          })
      }
    },
    getScheduleDifference (typeList) {
      // {'2024sz_1_6_pm':{ length:6, courses:[], linkUrl:'https://www.msup.com.cn/site/clause-activity?id=3784' }}
      if (typeList.length > 0) {
        // 初始化数据结构
        let difference = {}
        for (let type of typeList) {
          difference[type.name] = { length: 0, courses: [], linkUrl: '' }
          if (type.clauseActivityId) {
            difference[type.name].linkUrl = `https://www.msup.com.cn/site/clause-activity?id=${type.clauseActivityId}`
          }
          if (type.name.includes('am')) {
            difference[type.name].length = 3
          } else if (type.name.includes('pm')) {
            difference[type.name].length = 4
          }
          this.$forceUpdate()
        }
        // 获取数据
        let url = this.global.urlNew.sue['arr'] + this.global.config[this.global.area_id]['difference']
        this.$http
          .jsonp(url)
          .then((data) => {
            return data.json()
          })
          .then((res) => {
            if ([0, '0'].includes(res.errno) && res.data && res.data[0] && res.data[0].length > 0) {
              // console.log('difference ', res.data[0])
              for (let typeItem of typeList) {
                if (difference[typeItem.name]) {
                  difference[typeItem.name].courses = []
                  difference[typeItem.name].timeStamp = new Date().getTime()
                  // let course = {}
                  let lecturers = []
                  let lecturer = ''
                  let times = []
                  // let titles = []
                  // let title = ''
                  for (let index in res.data[0]) {
                    let course = res.data[0][index]
                    // if (course.detailType.toString().trim() === '281') {
                    if (course.detailType.toString().trim() === typeItem.id.toString().trim()) {
                      lecturers = course.content && course.content.length > 0 && course.content.split(' /// ')
                      if (course.content_note && course.content_note.length > 0) {
                        times = (course.content_note.split('scheduleTitle--')[0] || '').replace('time--', '').replace(/\r\n/g, '').split('-')
                        // titles = (course.content_note.split('scheduleTitle--')[1] || '').replace(/^\r\n/, '').split('\r\n')
                      }
                      difference[typeItem.name].courses.push({
                        courseId: (course.title && course.title.split('||') && course.title.split('||')[1]) || '',
                        courseTitle: (course.title && course.title.split('||') && course.title.split('||')[0]) || '敬请期待',
                        lecturers: [],
                        times: times,
                        file: (course.file && course.file.length > 2) ? course.file : ''
                      })
                      let cIndex = difference[typeItem.name].courses.length - 1
                      for (let lindex in lecturers) {
                        lecturer = lecturers[lindex] || ''
                        // title = titles[lindex] || '';
                        if (lecturer.split(' || ')[0] && lecturer.split(' || ')[0].trim() !== '客户技术高层') {
                          difference[typeItem.name].courses[cIndex].lecturers.push({
                            name: lecturer.split(' || ')[0] || '',
                            company: lecturer.split(' || ')[1] || '',
                            position: lecturer.split(' || ')[2] || ''
                            // courseTitle: title, // 不需要显示讲师议题
                          })
                        }
                      }
                    }
                  }
                  difference[typeItem.name].length = difference[typeItem.name].courses.length || difference[typeItem.name].length
                  // this.scheduleDifference = difference
                }
              }
              let dates = []
              for (let item of this.subjectlist) {
                if (!dates.includes(item.date)) {
                  dates.push(item.date)
                }
              }
              dates = dates.sort()
              // console.log('difference ', dates, difference, this.subjectlist)
              for (let tName of Object.keys(difference)) {
                for (let index in this.subjectlist) {
                  let item = this.subjectlist[index]
                  let y = this.global.config[this.global.area_id].year
                  let d = dates.indexOf(item.date) + 1
                  let g = item.groupId
                  let p = (item.times && item.times.slice(0, 2)) ? ((item.times.slice(0, 2) > '12' && item.times.slice(0, 2) < '20') ? 'pm' : 'am') : ''
                  let dKey = `${y}_${d}_${g}_${p}`
                  if (tName === dKey && difference[tName].courses && difference[tName].courses.length > 0) {
                    // console.log('difference ', tName, item, difference[tName])
                    this.subjectlist[index].differenceCourse = difference[tName].courses
                    for (let i = 0; i < this.subjectlist[index].differenceCourse.length; i++) {
                      this.showlist[index][1].push(true)
                    }
                    this.$forceUpdate()
                  }
                }
              }
            }
          })
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  // &.year_before {
  //   .subject-list .banner.search .input {
  //     input {
  //       border: 1px solid #0b70a4;
  //     }
  //     button {
  //       background-color: #0b70a4;
  //     }
  //   }
  // }
  // &.year_after {
  //   .subject-list .banner.search .input {
  //     input {
  //       border: 1px solid #024be7;
  //     }
  //     button {
  //       background-color: #024be7;
  //     }
  //   }
  // }
  .subject-list {
    .banner.search {
      color: var(--main-bgcolor);
      background: #ffffff;
      h1 {
        font-size: 40px;
        padding-top: 55px;
        padding-bottom: 35px;
        margin-top: 0;
        margin-bottom: 0;
      }
      .input {
        max-width: 610px;
        margin: 0 auto;
        margin-bottom: 25px;
        display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox; /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        input {
          width: 78%;
          height: 50px;
          line-height: 48px;
          margin: 0;
          padding-left: 20px;
          font-size: 16px;
          color: #cccccc;
          background: #ffffff;
          outline: none;
          border-color: var(--main-bgcolor);
        }
        button {
          width: 22%;
          height: 50px;
          line-height: 48px;
          margin-left: -5px;
          margin-top: 0px;
          padding: 0px;
          color: #ffffff;
          // background: #0b70a4;
          font-size: 20px;
          outline: none;
          border: none;
          outline: none;
          background-color: var(--main-bgcolor);
        }
      }
      .keyword {
        max-width: 767px;
        margin: 0 auto;
        a {
          font-size: 16px;
          color: #999999;
          padding-left: 10px;
          padding-right: 10px;
          line-height: 30px;
        }
      }
    }
    .pc_content {
      background-color: transparent;
      .con {
        max-width: 1125px;
        padding: 50px 0 100px 0;
        section {
          margin-bottom: 30px;
          .all_a {
            display: block;
            width: 100%;
            background-color: #fff;
            box-shadow: 0 1px 2px #ccc;
            margin-bottom: 15px;
            padding: 20px 25px;
            h1 {
              font-size: 19px;
              color: #1378d9;
              text-align: left;
            }
            p {
              font-size: 12.5px;
              color: #808080;
              line-height: 18.75px;
              padding-top: 15px;
              margin-bottom: 0;
            }
          }
          .all_a:hover {
            box-shadow: 3px 3px 13px #ccc;
            transition: all 0.3s;
          }
          ul {
            display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
            display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
            display: -ms-flexbox; /* TWEENER - IE 10 */
            display: -webkit-flex; /* NEW - Chrome */
            display: flex;
            flex-wrap: wrap;
            li {
              flex: none;
              width: 32%;
              background-color: #fff;
              border: 1px solid #e1e1e1;
              margin-bottom: 20px;
              margin-left: 2%;
              .all {
                padding-left: 3%;
                padding-right: 3%;
                display: block;
                padding-top: 9px;
                .top {
                  width: 100%;
                  margin: 0 auto;
                  display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
                  display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
                  display: -ms-flexbox; /* TWEENER - IE 10 */
                  display: -webkit-flex; /* NEW - Chrome */
                  display: flex;
                  .le {
                    width: 24.7%;
                    .img {
                      width: 100%;
                      overflow: hidden;
                      float: left;
                      position: relative;
                      img {
                        width: 100%;
                        &.per {
                          position: relative;
                          z-index: 2;
                        }
                        &.img-circle {
                          position: absolute;
                          top: 50%;
                          left: 50%;
                          z-index: 1;
                          transform: translateX(-50%) translateY(-50%);
                        }
                      }
                    }
                  }
                  .ri {
                    padding-left: 9px;
                    width: 75.3%;
                    float: left;
                    a {
                      h1 {
                        font-size: 15.62px;
                        line-height: 23.43px;
                        text-align: left;
                        color: #1378d9;
                        padding-top: 7px;
                      }
                    }
                    h2 {
                      font-size: 12.5px;
                      line-height: 17.18px;
                      color: #808080;
                      padding-top: 8px;
                    }
                  }
                }
                .bot {
                  margin-top: 14px;
                  padding-bottom: 15px;
                  .tag {
                    display: inline-block;
                    font-size: 12.5px;
                    color: #a2a2a2;
                    border: 1px solid #a2a2a2;
                    border-radius: 20px;
                    padding: 3px 15px;
                    margin-right: 8px;
                    margin-bottom: 5px;
                  }
                }
              }
            }
            li:nth-child(3n + 1) {
              margin-left: 0px;
            }
            li:hover {
              box-shadow: 3px 3px 13px #ccc;
              transition: all 0.3s;
            }
          }
        }
        .search_blank {
          width: 100%;
          text-align: center;
          font-size: 16px;
          line-height: 30px;
          letter-spacing: 1px;
          color: #666666;
        }
      }
    }
    @media (max-width:767px) {
      .banner.search {
        height: auto;
        .keyword {
          padding-bottom: 30px;
        }
      }
    }
    @media (max-width: 600px) {
      .banner.search {
        height: auto;
        h1 {
          font-size: 30px;
          padding-top: 35px;
          padding-bottom: 20px;
        }
        .input {
          max-width: 280px;
          input {
            width: 65%;
            height: 35px;
            padding-left: 10px;
            font-size: 12px;
          }
          button {
            width: 35%;
            height: 35px;
            line-height: 35px;
            margin-left: 0;
            border: none;
            font-size: 12px;
          }
        }
        .keyword {
          // background: #f9f9f9;
          padding: 15px 30px 30px;
          text-align: left;
          a {
            font-size: 12px;
            padding-left: 0;
            padding-right: 5px;
          }
        }
      }
      .pc_content {
        padding: 0;
        padding-top: 5vw;
        .con {
          width: 90%;
          padding-top: 0;
          section {
            .all_a {
              padding: 15px 13px;
              background-color: #f9f9f9;
              h1 {
                font-size: 14px;
              }
              p {
                font-size: 12px;
                line-height: 15px;
                padding-top: 10px;
              }
            }
            ul li {
                width: 100%;
                .all {
                  padding-top: 10px;
                  .top .ri {
                    a h1 {
                      font-size: 12px;
                      line-height: 15px;
                      padding-top: 3.5px;
                    }
                    h2 {
                      font-size: 12px;
                      line-height: 20px;
                      padding-top: 7px;
                    }
                  }
                }
              }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/SubjectList.vue